var _circle, _mask, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPurchase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 101,
    viewBox: "0 0 102 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.9317,
    cy: 50.4542,
    r: 50.4542,
    fill: "#F4F6F8"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 5,
    width: 83,
    height: 84
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 47.4774,
    cy: 47.0526,
    r: 41.0672,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.7149 47.0525C36.7149 47.8648 37.3733 48.5232 38.1855 48.5232C38.9978 48.5232 39.6562 47.8648 39.6562 47.0525H36.7149ZM75.2205 63.2553L74.2281 64.3407C74.6583 64.734 75.2801 64.8362 75.8135 64.6011C76.3469 64.3661 76.6912 63.8382 76.6912 63.2553H75.2205ZM70.0124 58.4936L71.0048 57.4082C70.7057 57.1347 70.307 56.9968 69.9028 57.027C69.4986 57.0572 69.1248 57.2529 68.8697 57.5678L70.0124 58.4936ZM66.1546 63.2553L64.869 63.9696C65.1063 64.3967 65.5402 64.6781 66.027 64.7205C66.5137 64.7629 66.9898 64.5608 67.2974 64.1812L66.1546 63.2553ZM66.4758 60.8051C66.0813 60.095 65.186 59.8392 64.476 60.2337C63.7659 60.6281 63.5101 61.5235 63.9045 62.2335L66.4758 60.8051ZM44.0683 23.4475H69.3377V20.5061H44.0683V23.4475ZM73.7498 27.8596V57.3033H76.6912V27.8596H73.7498ZM39.6562 47.0525V27.8596H36.7149V47.0525H39.6562ZM73.7498 57.3033V63.2553H76.6912V57.3033H73.7498ZM76.2128 62.1699L71.0048 57.4082L69.02 59.579L74.2281 64.3407L76.2128 62.1699ZM68.8697 57.5678L65.0119 62.3295L67.2974 64.1812L71.1552 59.4194L68.8697 57.5678ZM67.4403 62.5411L66.4758 60.8051L63.9045 62.2335L64.869 63.9696L67.4403 62.5411ZM69.3377 23.4475C71.7744 23.4475 73.7498 25.4229 73.7498 27.8596H76.6912C76.6912 23.7984 73.3989 20.5061 69.3377 20.5061V23.4475ZM44.0683 20.5061C40.0071 20.5061 36.7149 23.7984 36.7149 27.8596H39.6562C39.6562 25.4229 41.6316 23.4475 44.0683 23.4475V20.5061Z",
    fill: "#173559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0376 41.9471V28.5808C42.0376 26.9563 43.3545 25.6433 44.979 25.6433H68.9942C70.6187 25.6433 71.9356 26.9602 71.9356 28.5847V48.7934C71.9356 49.4179 71.7368 50.0263 71.368 50.5303L69.6302 52.9053C68.2053 54.8526 65.1662 54.3221 64.4854 52.0072C63.7562 49.5281 61.481 47.8257 58.8969 47.8257H47.9204C44.6714 47.8257 42.0376 45.196 42.0376 41.9471Z",
    fill: "#FDCF33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.9394,
    y: 52.3806,
    width: 37.5655,
    height: 25.9921,
    rx: 4.41209,
    fill: "#D7E7FF",
    stroke: "#173559",
    strokeWidth: 2.94139
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.3999,
    y: 58.6252,
    width: 36.6491,
    height: 1.9289,
    fill: "#173559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1904 70.1969C28.1904 69.5577 28.7086 69.0396 29.3478 69.0396H38.608C39.2472 69.0396 39.7653 69.5577 39.7653 70.1969C39.7653 70.8361 39.2472 71.3542 38.608 71.3542H29.3478C28.7086 71.3542 28.1904 70.8361 28.1904 70.1969Z",
    fill: "#173559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9809 30.4648C65.5135 30.4648 65.9453 30.8966 65.9453 31.4293L65.9453 35.2871C65.9453 35.8198 65.5135 36.2515 64.9809 36.2515C64.4482 36.2515 64.0164 35.8197 64.0164 35.2871L64.0164 31.4293C64.0164 30.8966 64.4482 30.4648 64.9809 30.4648Z",
    fill: "#173559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0928 33.3575C62.0928 32.8249 62.5246 32.3931 63.0572 32.3931H66.915C67.4477 32.3931 67.8795 32.8249 67.8795 33.3575C67.8795 33.8902 67.4477 34.322 66.915 34.322H63.0572C62.5246 34.322 62.0928 33.8902 62.0928 33.3575Z",
    fill: "#173559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0928 41.0733C62.0928 40.5407 62.5246 40.1089 63.0572 40.1089H66.915C67.4477 40.1089 67.8795 40.5407 67.8795 41.0733C67.8795 41.606 67.4477 42.0378 66.915 42.0378H63.0572C62.5246 42.0378 62.0928 41.606 62.0928 41.0733Z",
    fill: "#173559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3405 32.6624C54.5545 31.9577 53.6735 31.4156 52.4267 31.2665V29.5318H51.0986V31.253C49.3097 31.4563 48.1848 32.5269 48.1848 34.1261C48.1848 37.338 53.5245 36.7959 53.5245 38.5577C53.5245 39.3437 52.9011 39.7774 51.5323 39.7774C50.5294 39.7774 49.4994 39.425 48.6592 38.6797L47.7647 40.0213C48.5914 40.8209 49.9873 41.2682 51.0986 41.3766V43.0842H52.4267V41.3359C54.3647 41.0649 55.4354 39.9265 55.4354 38.3815C55.4354 35.0883 50.0957 35.671 50.0957 33.9905C50.0957 33.2181 50.7733 32.8386 51.7898 32.8386C52.7249 32.8386 53.538 33.2045 54.3376 33.855L55.3405 32.6624Z",
    fill: "#173559"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchase);
export default __webpack_public_path__ + "static/media/purchase.bb20703e87190a09118bad0e5f7c6376.svg";
export { ForwardRef as ReactComponent };